import Home from "../../components/Dashboard/Dashboard";

export default function HomePage() {
  return (
    <div>
      <Home />
    </div>
  );
}
